<script setup>
import { onMounted, watch, shallowRef } from 'vue'

const props = defineProps({
  name: { type: String, required: true },
  color: String,
})

const iconComponent = shallowRef (null)

const loadIcon = () => {
  import(`../../assets/svg/${props.name}.svg?url`).then((module) => {
    iconComponent.value = module.default
  }).catch((error) => {
    console.error('Error loading icon:', error)
  })
}

watch(() => props.name, (newName) => {
  loadIcon()
})

onMounted(() => {
  loadIcon()
})

</script>

<template>
  <div
    v-if="iconComponent"
    class="w-[1.5em] h-[1.5em] inline-block
           [mask-size:contain] [mask-position:center] [mask-repeat:no-repeat]
           [-webkit-mask-size:contain] [-webkit-mask-position:center] [-webkit-mask-repeat:no-repeat]"
    :style="{
      maskImage: `url(${iconComponent})`,
      WebkitMaskImage: `url(${iconComponent})`,
      backgroundColor: props.color || 'currentColor'
    }"
    :key="props.name"
  />
</template>

